export const PromptPlaceholder = () => (
    <div className="card card-body">
        <div className="border border-3 border-primary">
            <div className="vstack gap-3 placeholder-glow p-3">
                <div className="vstack gap-2 align-items-center">
                    <div className="placeholder bg-secondary col-12"></div>
                    <div className="placeholder bg-secondary col-8"></div>
                </div>
                <div className="placeholder bg-dark py-7"></div>
            </div>
        </div>
    </div>
);
